export const socialLinks = [
  { name: 'Instagram', url: 'https://www.instagram.com/vicinity_asia/', icon: 'instagram' },
  { name: 'Threads', url: 'https://www.threads.net/@vicinity_asia', icon: 'threads' },
  { name: 'TikTok', url: 'https://www.tiktok.com/@vicinity_asia', icon: 'tiktok' },
  { name: 'YouTube', url: 'https://www.youtube.com/@vicinitystudio', icon: 'youtube' },
  { name: 'Facebook', url: 'https://www.facebook.com/vicinity.studio', icon: 'facebook' },
  { name: 'LinkedIn', url: 'https://www.linkedin.com/company/vicinityasia', icon: 'linkedin' },
  { name: 'Vimeo', url: 'https://vimeo.com/vicstudio', icon: 'vimeo' },
  { name: 'Blog', url: 'https://vicinity.studio/blog', icon: 'blog' }
];

export const chinaLinks = [
  {
    name: 'Xiaohongshu',
    chinese: '小红书',
    handle: 'Vicinity惟心汀传媒',
    url: 'https://www.xiaohongshu.com/user/profile/6ad9984d000000000c02f404',
    icon: 'xiaohongshu'
  },
  {
    name: 'Weibo',
    chinese: '微博',
    handle: '@Vicinity惟心汀',
    url: 'https://weibo.com/u/8209887810',
    icon: 'weibo'
  }
];